import { useState } from "react";
import { homeFor } from "@/components/shared";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Loader2, ArrowLeft } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { BRAND, IMG, LOGO } from "@/lib/brand";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Field } from "@/components/common";

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to={homeFor(user.role)} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      const u = await login(email, password);
      nav(homeFor(u.role), { replace: true });
    } catch (e2) {
      setErr(errMsg(e2));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#FAF8F5]">
      <div className="relative hidden lg:block">
        <img src={IMG.urne} alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#082535] via-[#0D3B52]/60 to-transparent" />
        <div className="absolute bottom-12 left-12 right-12 text-white">
          <p className="font-display text-4xl leading-tight">"Il nostro non è un lavoro,<br />ma una missione."</p>
          <p className="text-sm text-white/70 mt-4">{BRAND.name} · {BRAND.address}</p>
        </div>
      </div>
      <div className="flex items-center justify-center p-6 sm:p-12">
        <div className="w-full max-w-md rise">
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-[#5C6B73] hover:text-[#0D3B52] mb-10" data-testid="login-back-link">
            <ArrowLeft className="h-4 w-4" /> Torna al sito
          </Link>
          <img src={LOGO} alt={BRAND.name} className="h-12 w-auto" />
          <h1 className="font-display text-4xl font-semibold text-[#0D3B52] mt-8">Area riservata</h1>
          <p className="text-sm text-[#5C6B73] mt-2">Accesso per veterinari convenzionati e amministrazione.</p>
          <form onSubmit={submit} className="space-y-5 mt-8" data-testid="login-form">
            <Field label="Email">
              <Input data-testid="login-email-input" type="text" placeholder="Email o numero di cellulare" required value={email} onChange={(e) => setEmail(e.target.value)} className="bg-white h-11" />
            </Field>
            <Field label="Password">
              <Input data-testid="login-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="bg-white h-11" />
            </Field>
            {err && <p className="text-sm text-rose-700" data-testid="login-error">{err}</p>}
            <Button type="submit" disabled={busy} data-testid="login-submit-button" className="w-full h-12 rounded-full bg-[#0D3B52] hover:bg-[#082535] text-base">
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Accedi"}
            </Button>
          </form>
          <p className="text-xs text-[#5C6B73] mt-8">Sei un veterinario e non hai le credenziali? Chiamaci al {BRAND.phone}.</p>
        </div>
      </div>
    </div>
  );
}
